import axiosInstance from "../../../services/axiosInstance";

export const postSection = async (payload) => {
  try {
    return await axiosInstance.post("/CallFlow", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    // swallow — caller handles missing return value
  }
};

export const fetchSections = async () => {
  return await axiosInstance.get("/CallFlow");
};

export const updateCallFlow = async (dbId, payload) => {
  return await axiosInstance.put(`/CallFlow/${dbId}`, payload);
};

export const upsertRingGroup = async (payload) => {
  return await axiosInstance.put('/RingGroup', payload);
};

export const upsertAgents = async (payload) => {
  return await axiosInstance.put('/Agents', payload);
};

export const upsertQueueSettings = async (payload) => {
  return await axiosInstance.put('/QueueSettings', payload);
};

// Atomic: updates CallFlow + cleans stale routing rows + writes correct tables in one transaction
export const upsertSectionRouting = async (payload) => {
  return await axiosInstance.put('/SectionRouting', payload);
};
